import { connect } from "react-redux";
import { getWithdraw, getSession } from "../../selectors";
import React from "react";
import requireAuthentication from "../../components/higher-order/require-authentication";
import Steps from "../../components/withdraw/steps";
import { withRouter } from "react-router-dom";

class W9Page extends React.PureComponent {
  constructor(props) {
    super(props);

    var { withdraw, history } = props;
    if (!withdraw.get("amount") || !withdraw.get("confirmed")) {
      history.push("/withdraw");
    }
  }

  render() {
    var { session, withdraw } = this.props;

    return (
      <div className="l-wrapper">
        <div className="l-content l-content--80-percent">

          <Steps isW9 session={session} withdraw={withdraw} />

          <h1 className="text-center">
            W-9 Form
          </h1>

          <h2 className="color--is-lime">
            <i className="dw-checkmark3 dw--baseline" />

            {" "}
            Withdrawal Request Received
          </h2>

          <div className="notification notification--caution notification--is-visible">
            <div className="notification_content">
              <div className="notification_icon">
                <i className="dw-warning6" />
              </div>

              <div className="notification_body">
                <h2 className="notification_title">
                  Alert! Information required for your withdrawal.
                </h2>

                <p>
                  <span className="text--is-bold">
                    Your withdrawal cannot be sent
                  </span>

                  {" "}
                  until the following information is submitted:

                  <span className="text--is-bold text--is-italic">
                    W-9 Form
                  </span>
                </p>
              </div>
            </div>
          </div>

          <div className="l-content">
            <p>
              Please download the
              {" "}

              <span className="text--is-bold text--is-italic">
                W-9 Form
              </span>

              {" "}
              below and return it to

              {" "}

              {window.env.brandName}

              {" "}
              by email or fax:
            </p>

            <div className="padding-left--is-20 margin-bottom--is-20">
              <p>
                By email:
                {" "}

                <a className="link--is-white" href="mailto:support@derbywars.com?subject=DerbyWars W-9 Form">
                  support@derbywars.com
                </a>
              </p>

              <p>
                Or by fax: 815-331-0937
              </p>

              <p>
                <a className="btn btn--primary" href="https://www.irs.gov/pub/irs-pdf/fw9.pdf" rel="noopener noreferrer" target="_blank">
                  <i className="dw-file-pdf-o" />

                  {" "}
                  W-9 Form (PDF)
                </a>
              </p>
            </div>

            <p>
              Your withdrawal will be processed upon receiving your W-9 Form.
            </p>

            <p>
              <a className="link--is-white" href="http://blog.derbywars.com/terms-of-use#policy-of-sponsor" rel="noopener noreferrer" target="_blank">
                Click here
              </a>

              {" "}
              for additional information on applicable taxes on contest winnings.
            </p>
          </div>
        </div>
      </div>
    );
  }
}

function select(state) {
  return {
    withdraw: getWithdraw(state),
    session: getSession(state)
  };
}

export default connect(select)(requireAuthentication(withRouter(W9Page)));
